import { booleanAttribute, Component, forwardRef, input } from '@angular/core';
import { Tabs, TabsStyle } from 'primeng/tabs';

/**
 * Список табов pa-tab, которые будут работать как ссылки
 *
 * Пример использования:
 * @example
 * ```html
 * <pa-router-tabs>
 *   <p-tablist>
 *     <pa-tab [routerLink]="['/users']">Сотрудники</pa-tab>
 *     <pa-tab [routerLink]="['/pvzs']">Пункты выдачи</pa-tab>
 *   </p-tablist>
 * </pa-router-tabs>
 * ```
 */
@Component({
  selector: 'pa-router-tabs',
  standalone: true,
  imports: [Tabs],
  providers: [
    TabsStyle,
    {
      provide: Tabs,
      useExisting: forwardRef(() => PaRouterTabsComponent),
    },
  ],
  templateUrl: './pa-router-tabs.component.html',
  styleUrls: ['./pa-router-tabs.component.scss'],
})
export class PaRouterTabsComponent extends Tabs {
  override scrollable = input(true, { transform: booleanAttribute });
}
